/**
 * Haptic feedback (mobile), shared by every game. navigator.vibrate is Android/Chrome;
 * iOS Safari ignores it silently (no-op, no throw) — progressive enhancement, never
 * required. Honors prefers-reduced-motion.
 */

function reducedMotion(): boolean {
  try {
    return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch {
    return false;
  }
}

function buzz(pattern: number | number[]): void {
  try {
    if (reducedMotion()) return;
    navigator.vibrate?.(pattern);
  } catch {
    /* unsupported — ignore */
  }
}

export const haptic = {
  /** Crisp confirm on a valid tap. */
  tap: () => buzz(20),
  /** Sharp double-pulse penalty on an early tap (reflex). */
  tooSoon: () => buzz([40, 40, 40]),
  /** Round recorded (reflex). */
  round: () => buzz(15),
  /** Celebration: new personal best / streak up. */
  newBest: () => buzz([0, 50, 50, 90]),
  /** Run finished (no new best). */
  done: () => buzz(30),
  /** Wheel landed on a wedge. */
  land: () => buzz(25),
};
